<template>
  <Row style="padding: 20px">
    <Col span="24">
      <Select
        v-model="params.changeEvent"
        placeholder="请选择分类"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option value="采购入库">采购入库</Option>
        <Option value="下单扣除">下单扣除</Option>
        <Option value="回滚">回滚</Option>
      </Select>
      <Select
        v-model="params.changeType"
        placeholder="请选择类型"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option value="增加">增加</Option>
        <Option value="减少">减少</Option>
      </Select>
      <Select
        v-model="params.areaCode"
        placeholder="请选择省份"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option v-for="(item, i) in province" :key="i" :value="item.code">{{
          item.name
        }}</Option>
      </Select>
      <Select
        v-model="params.skuCode"
        placeholder="请选择sku"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="item in SKUList.data || []"
          :key="item.code"
          :value="item.code"
          >{{ item.name || "" }}</Option
        >
      </Select>
      <Select
        v-model="params.spCode"
        placeholder="请选择资金商"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="item in spInfoQueryAll || []"
          :key="item.code"
          :value="item.code"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="params.gradeGroup"
        placeholder="请选择渠道"
        class="public-inp"
      >
        <Option value="">全部</Option>
        <Option
          v-for="(item,index) in baseChannelList || []"
          :key="index"
          :value="item"
          >{{ item }}</Option
        >
      </Select>
      <Select
        v-model="params.wmsCode"
        placeholder="请输入仓库名称"
        filterable
        clearable
        :remote-method="handleCreate1"
        @on-select="handleCreate2"
        :loading="wmsCodeLoading"
        class="public-inp"
      >
        <Option
          v-for="(option, i) in wmsCodeList"
          :value="option.wmsCode"
          :key="i"
          >{{ option.wmsName }}</Option
        >
      </Select>
      <Button type="primary" icon="md-search" @click="getList" v-access="'inventoryLog.query'">搜索</Button>
      <Button @click="resetList" v-access="'inventoryLog.reset'">重置</Button>
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="wmsHistoryList.data || []"
      >
        <template slot-scope="{ index }" slot="no">
          <span>{{ params.pageSize * (params.page - 1) + index + 1 }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a style="margin-right: 5px" @click="detail(row, index)">查看</a>
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="wmsHistoryList.total"
        show-sizer
        show-total
        prev-text="Previous"
        next-text="Next"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  //   {
  //     title: "ID",
  //     key: "id",
  //   },
  {
    title: "省份",
    key: "areaName",
  },
  //   {
  //     title: "省份编码",
  //     key: "areaCode",
  //   },
  {
    title: "分类",
    key: "changeEvent",
  },
  {
    title: "类型",
    key: "changeType",
  },
  {
    title: "数量",
    key: "count",
  },
  {
    title: "资金商名称",
    key: "fwName",
  },
  //   {
  //     title: "服务商编码",
  //     key: "spCode",
  //   },
  {
    title: "GRADE GROUP",
    key: "gradeGroup",
  },
  //   {
  //     title: "skuCode",
  //     key: "skuCode",
  //   },
  {
    title: "skuName",
    key: "skuName",
  },
  {
    title: "仓库名称",
    key: "wmsName",
  },
  //   {
  //     title: "创建时间",
  //     key: "createtime",
  //   },
  {
    title: "更新时间",
    key: "updatetime",
  },
  {
    title: "备注",
    key: "remark",
  },
  //   {
  //     title: "操作",
  //     slot: "action"
  //   },
];
export default {
  data() {
    return {
      loading: false,
      columns,

      wmsCodeList: [],
      areaCodeList: [],
      params: {
        pageSize: 10,
        page: 1,
        areaCode: "",
        changeEvent: "", //采购入库,下单扣除 回滚
        gradeGroup: "",
        skuCode: "",
        spCode: "",
        wmsCode: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      wmsHistoryList: "warehouse/getWmsHistoryList",
      SKUList: "stageInfo/getSKUList",
      province: "base/getBaseAreaAll",
      spInfoQueryAll: "merchant/getSpInfoQueryAll",
      baseChannelList: "warehouse/getWmsBaseChannelList",
    }),
  },
  created() {
    this.getList();
    // 查询所有仓库
    this.handleCreate1("");
    // 查询所有省份
    this.$store.dispatch("base/getBaseAreaAll");
    // 查询所有SKU
    this.$store.dispatch("stageInfo/getSKUList", {
      pageSize: 100,
    });
    // 查询资金商&服务商
    this.$store.dispatch("merchant/getSpInfoQueryAll");
    //查询渠道列表
    this.$store.dispatch("warehouse/getWmsBaseChannelList");
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("warehouse/getWmsHistoryList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.page == 1) {
        this.getList();
      } else {
        this.params.page = 1;
      }
    },
    // 重置
    resetList() {
      this.params.page = 1;
      this.params.pageSize = 10;
      this.params.areaCode = "";
      this.params.changeEvent = "";
      this.params.gradeGroup = "";
      this.params.skuCode = "";
      this.params.spCode = "";
      this.params.wmsCode = "";
      this.getList();
    },
    // 添加
    create() {
      this.$router.push({
        path: "create",
        // query:
      });
    },
    // 详情
    detail(row, index) {
      this.$router.push({
        path: "detail",
        query: {
          code: row.code,
        },
      });
    },
    handleCreate1(val) {
      let data = { name: val };
      this.wmsCodeLoading = true;
      this.$api.wareVagueSearch(data).then((res) => {
        this.wmsCodeLoading = false;
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    handleCreate2(code) {
      this.wmsCodeList.forEach((item) => {
        if (item.wmsCode == code) {
          this.params.wmsCode = code;
        }
      });
    },
  },
};
</script>
<style scoped>
.search {
  margin-right: 15px;
  width: 300px;
}
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/inventoryLog.vue